import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
} from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LoadingService } from './loading.service';

/**
 * Interceptor para mostrar indicadores de loading durante peticiones HTTP
 * Permite excluir peticiones específicas mediante header 'X-Skip-Loading'
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  private readonly SKIP_LOADING_HEADER = 'X-Skip-Loading';

  constructor(private loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Verificar si esta petición debe omitir el loading
    const skipLoading = request.headers.has(this.SKIP_LOADING_HEADER);

    // Remover el header antes de enviar la petición
    if (skipLoading) {
      request = request.clone({
        headers: request.headers.delete(this.SKIP_LOADING_HEADER)
      });
    }

    if (!skipLoading) {
      this.totalRequests++;
      if (this.totalRequests === 1) {
        this.loadingService.setLoading(true);
      }
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!skipLoading) {
          this.totalRequests--;
          if (this.totalRequests === 0) {
            this.loadingService.setLoading(false);
          }
        }
      })
    );
  }
}
